import React, { Component } from 'react';

import { reduxForm } from 'redux-form';

import {FormattedHTMLMessage} from 'react-intl';
import axios from 'axios';

import { formatMoney } from '../utils/utils.js';
import withAuthControl from '../auth/Auth.js';
import TopScrolleable from './TopScrolleable.js';
import generateValidator from './Validations/generateValidator';

import Section from './Section.js';
import AttributeOptions from './AttributeOptions.js';
import CustomSpinner from './CustomSpinner.js';
import LoadField from '../components/LoadField';
import SaveStepButton from './SaveStepButton';

import Whatsapp from './WhatsappButton.js';

require(`../assets/${process.env.PAGE}/css/components/available-amount-form.css`);


class AvailableAmountForm extends Component {
    constructor(props){
        super(props);

        this.state = {
            available_amount: null,
        };
    }

    componentDidMount() {
        const ROOT_URL = process.env.API_URL;
        const config = {
            headers:
                {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
                }
        };
        axios.get(`${ROOT_URL}/steps/params`, config).then((response)=> {
            this.setState({
                available_amount: response.data.loan_amount,
            });
        });
    }


    render() {
        const { handleSubmit, submitting, error } = this.props;
        const { available_amount } = this.state;
        const accept_amount_options = [{id:0 , name:'Si'}, {id:1 , name:'No'}]


        return (

             <Section className="intro_form">
                <div className="row">
                    <div className="pd-content-left col-md-5 col-lg-5 text-center">
                        <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo-h-blanco.png`)}/>
                        <div className="show-desktop">
                            <Whatsapp phone={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_number", defaultMessage: "542612554220"})}
                                    text={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_text", defaultMessage: "Tengo+una+consulta"})}
                                    value={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_label", defaultMessage: "261-2554-220"})}
                                    gaEvent="true" gaCategory="CallToAction" gaAction="WhatsApp Tapping"/>
                            <FormattedHTMLMessage id="app.whatsapp_timetable" description="Wp timetable"/>
                            <SaveStepButton/>
                        </div>
                    </div>
                    <div className="pd-content-right text-center short-content col-sm-12 col-md-7 col-lg-7">
                         <form onSubmit={handleSubmit(this.props.acceptAmount)} className="pvc-form">
                         <FormattedHTMLMessage id="app.step_available_amount" description="Available Amount info"/>
                            <LoadField>
                                { available_amount ? (<div className={'available-amount'}>{`${formatMoney(available_amount, 2, ',', '.')} pesos`}</div>) : null }
                            </LoadField>
                            {this.props.isLoading && <CustomSpinner message='Estamos analizando tu solicitud. Por favor esperá...' /> }
                            {error && <CustomAlert bsStyle="danger" message={error}/>}
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                    <div className="form-group">
                                        <AttributeOptions name="accept_amount" defaultValue="¿Querés continuar con la solicitud?" label="¿Querés continuar con la solicitud?" attributeName='accept_amount' attributeOptions={accept_amount_options}/>
                                    </div>
                                </div>
                            </div>
                            <FormattedHTMLMessage id="app.step_available_amount_description" description="Available Amount info"/>
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                                    <button type="submit" className="btn btn-warning btn-lg pd-button pd-form" disabled={submitting}>Continuar</button>
                                </div>
                            </div>
                        </form>
                        <div className="show-mobile">
                            <Whatsapp phone={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_number", defaultMessage: "542612554220"})}
                                    text={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_text", defaultMessage: "Tengo+una+consulta"})}
                                    value={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_label", defaultMessage: "261-2554-220"})}
                                    gaEvent="true" gaCategory="CallToAction" gaAction="WhatsApp Tapping"/>
                            <FormattedHTMLMessage id="app.whatsapp_timetable" description="Wp timetable"/>
                            <SaveStepButton/>
                        </div>
                    </div>
                </div>
            </Section>
        );
    }
}

AvailableAmountForm.contextTypes = {
    intl: React.PropTypes.object.isRequired
}

let validate = generateValidator([{name: 'accept_amount', required: true}])

AvailableAmountForm = TopScrolleable(AvailableAmountForm);

AvailableAmountForm = reduxForm({
    form: 'AvailableAmountForm', // a unique name for this form
    validate,
})(AvailableAmountForm);

AvailableAmountForm = withAuthControl(AvailableAmountForm);

export default AvailableAmountForm;



/** WEBPACK FOOTER **
 ** ./src/components/AvailableAmountForm.js
 **/